export const PRODUCTION = "production";
export const DEVELOPMENT = "development";
export const API_DEV_URL = "https://uat.trademo.com/trademo"; // This is for UAT
// export const API_DEV_URL = 'https://staging1.trademo.com/trademo'; // This is for Staging 1
export const GLOBAL_API_DEV_URL = "https://uatusermanagement.trademo.com/trademo"; // This is for Staging after UMS
export const S_K_DEV = "pk_test_51H55FUIREutAm1mBDihQXRwiNmDMFI7DZcprWrjYL1jTGTdfoK8FOmH9nv51jRqpBt6N5eXa2Y2RwHJUZaFX2a8y00O4vhAMcw";
export const G_A_K_DEV = "";
export const LOCAL_WEBSITE_URL = "http://localhost:3011/";
export const LOCAL_ACCOUNTS_URL = "http://localhost:3002/";
export const LOCAL_INTEL_URL = "http://localhost:5173/";
export const LOCAL_SOURCE_ATLAS_URL = "http://localhost:5173/";
export const LOCAL_SANCTIONS_URL = "http://localhost:3000/";
export const LOCAL_PAYMENTS_URL = "http://localhost:3004/";
export const LOCAL_COMPLIANCE_URL = "http://localhost:3012/";
export const SEND_BLUE_KEY_DEV = "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";
export const LOCAL_WEBSITE_VARIENT = 2;
export const COMPLIANCE_DEV_URL = "http://localhost:3012/";
export const SANCTIONS_DEV_URL = "https://preprodsanctions.trademo.com/";
export const LOCAL_HS_CODE_CLASSIFICATION_URL = "http://localhost:3025";
export const LOCAL_PRODUCT_MASTER_URL = "http://localhost:3017/";
export const LOCAL_SUPPLY_CHAIN_URL = "http://localhost:3030/";
export const LOCAL_TRADE_MAP_URL = "http://localhost:3000/";
export const LOCAL_USER_MANAGEMENT_SYSTEM_URL = "http://localhost:3020";
export const LOCAL_FIN_SCREENER = "http://localhost:3005";
